export function mapTypescriptRecord<
  Keys extends string,
  InputValues,
  ReturnValues,
>(
  input: Record<Keys, InputValues>,
  mappingFunction: (a: InputValues) => ReturnValues,
): Record<Keys, ReturnValues> {
  const newValues = Object.entries<InputValues>(input).map(([key, value]) => ({
    [key]: mappingFunction(value),
  }))

  return Object.assign({}, ...newValues) as Record<Keys, ReturnValues>
}

export function recordArrayToRecord<Keys extends string, Values>(
  inputArray: Record<Keys, Values>[],
): Record<Keys, Values> {
  return Object.assign({}, ...inputArray) as Record<Keys, Values>
}

function computeNewValue<Values>(
  newValue: Values[],
  recordInputElement: Values,
): Values[] {
  if (!newValue) {
    return [recordInputElement]
  }
  return [...newValue, recordInputElement]
}

export function mergeRecordArrayToRecord<Keys extends string, Values>(
  inputArray: Record<Keys, Values>[],
): Record<Keys, Values[]> {
  const newValues: Record<Keys, Values[]> = {} as Record<Keys, Values[]>
  for (const recordInput of inputArray) {
    for (const key in recordInput) {
      const recordInputElement: Values = recordInput[key]
      if (recordInputElement) {
        newValues[key] = computeNewValue(newValues[key], recordInputElement)
      }
    }
  }
  return newValues
}

export function deleteRecordElement<Keys extends string, Values>(
  inputRecord: Record<Keys, Values>,
  elementKeyToDelete: Keys,
): Record<Keys, Values> {
  const newRecord = { ...inputRecord }
  // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
  delete (newRecord as Record<string, Values>)[elementKeyToDelete]
  return newRecord
}
